







































import Vue from 'vue'
import {Component, Watch, Provide} from 'vue-property-decorator'
import music from '@/views/search/searchMusic.vue'
import artists from '@/views/search/searchArtist.vue'
import albums from '@/views/search/searchAlbum.vue'

@Component({
    components: {
        music,
        artists,
        albums
    }
})
export default class Search extends Vue {
    @Provide() tabView = 'all'
    @Provide() loader = true

    slicedStuffs (obj: any, num: any) {
        return obj.slice(0,num)
    }

    @Watch('$route.params.query')
    onPropertyChange(newValue: any, oldValue: any) {
        this.$store.dispatch('trackModule/fetchSearchedTracks', newValue)
        this.$store.dispatch('artistModule/fetchSearchedArtists', newValue)
    }


    get tracks () {
        return this.$store.getters['trackModule/getTracks']
    }
    get artists () {
        return this.$store.getters['artistModule/getArtistsTotal']
    }
    get albums () {
        return this.$store.getters['albumModule/getAlbums']
    }

    created () {
        this.$store.dispatch('trackModule/fetchSearchedTracks', this.$route.params.query).then(()=> {
            this.loader = false
        })
        this.$store.dispatch('artistModule/fetchSearchedArtists', this.$route.params.query)
        this.$store.dispatch('albumModule/fetchSearchrdAlbums', this.$route.params.query)
    }
}
